import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "cardSize"];
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { SkeletonBlock, SkeletonWrapper } from './subcomponents/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentCardSkeleton = _ref => {
  let {
      use = 'on-light',
      cardSize
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  const skeletonColor = use === 'on-dark' ? 'fill-accent-neutral-default' : 'fill-accent-neutral-subtle-alt';
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    borderRadius: "300",
    "data-test-id": "content-card-skeleton",
    marginInlineEnd: isMobile ? '400' : undefined
  }, props, {
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: use === 'on-light' || use === 'on-surface-recessed' ? 'fill-surface-default' : use === 'on-dark' ? 'fill-accent-neutral-pressed' : 'fill-accent-neutral-subtle-alt',
      blockSize: cardSize === 'large' ? '295px' : '356px',
      children: /*#__PURE__*/_jsxs(SkeletonWrapper, {
        borderRadius: "300",
        shimmerColor: use === 'on-dark' ? 'fill-accent-neutral-pressed' : undefined,
        children: [/*#__PURE__*/_jsx(SkeletonBlock, {
          color: skeletonColor,
          height: cardSize === 'large' ? '169px' : '231px'
        }), /*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsxs(View, {
            paddingInline: "250",
            children: [/*#__PURE__*/_jsx(View, {
              marginBlockStart: "600",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "95%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "600",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "45%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "200",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "20%"
              })
            })]
          })
        })]
      })
    })
  }));
};
export default ContentCardSkeleton;